module.exports = __webpack_public_path__ + "img/1050_help_title_a94e8dd57.png";